module.exports = __webpack_public_path__ + "img/13_40.491d46e1.png";